import React, { useState } from 'react';
import { receivePortalJob } from '../api';
import { intakeLabel } from './IncomingJobs';
import './incomingjobs.css';

// Top of a job sent in on the commercial portal: who sent it, pickup or drop-off, and
// (while its wheels haven't arrived) the Picked up / Received button.
function PortalJobBanner({ job }) {
  const [received, setReceived] = useState(job.is_incoming ? null : job.received_at);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  if (job.source !== 'portal') return null;

  const receive = async () => {
    setBusy(true);
    setError('');
    try {
      const updated = await receivePortalJob(job.id);
      setReceived(updated.received_at);
      window.dispatchEvent(new CustomEvent('portal-job-received', { detail: updated }));
    } catch {
      setError('Could not save. Try again.');
    } finally {
      setBusy(false);
    }
  };

  const when = (iso) => new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  const pickup = job.intake_method === 'pickup';
  // Archived while still waiting for its wheels: the customer sees it as cancelled.
  const cancelled = !received && job.is_archived;

  return (
    <div className={`portal-banner ${received ? '' : 'portal-banner-waiting'}`}>
      <div className="portal-banner-text">
        <strong>Sent in on the customer portal</strong>
        {job.portal_submitted_by_name ? ` by ${job.portal_submitted_by_name}` : ''}
        {intakeLabel(job) ? ` · ${intakeLabel(job)}` : ''}
        {received
          ? ` · ${pickup ? 'Picked up' : 'Received'} ${when(received)}`
          : cancelled ? ' · Cancelled before the wheels came in (unarchive to bring it back)' : ' · Waiting for the wheels'}
        {error && <span className="portal-banner-error"> {error}</span>}
      </div>
      {!received && !cancelled && (
        <button type="button" className="incoming-receive" disabled={busy} onClick={receive}>
          {busy ? 'Saving…' : pickup ? 'Picked up' : 'Received'}
        </button>
      )}
    </div>
  );
}

export default PortalJobBanner;
